import { useEffect, useState, ReactNode } from "react";

type EdgeGlowProps = {
  children?: ReactNode;
  color?: 'teal' | 'blue' | 'purple' | 'green';
  intensity?: 'low' | 'medium' | 'high';
};

export function EdgeGlow({ children, color = 'teal', intensity = 'medium' }: EdgeGlowProps) {
  // Set base opacity based on intensity
  const baseOpacity = intensity === 'low' ? 0.1 : intensity === 'medium' ? 0.2 : 0.3;
  const [opacity, setOpacity] = useState(baseOpacity);
  const [increasing, setIncreasing] = useState(true);
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (increasing) {
        setOpacity((prev) => {
          const newOpacity = prev + 0.01;
          const maxOpacity = baseOpacity + 0.1;
          if (newOpacity >= maxOpacity) {
            setIncreasing(false);
          }
          return newOpacity;
        });
      } else {
        setOpacity((prev) => {
          const newOpacity = prev - 0.01;
          const minOpacity = baseOpacity - 0.1;
          if (newOpacity <= minOpacity) {
            setIncreasing(true);
          }
          return newOpacity;
        });
      }
    }, 100);
    
    return () => clearInterval(interval);
  }, [increasing, baseOpacity]);
  
  // Get color values based on prop
  const getColorValue = () => {
    switch (color) {
      case 'teal': return '0,194,203';
      case 'blue': return '0,122,255';
      case 'purple': return '175,82,222';
      case 'green': return '52,199,89';
      default: return '0,194,203';
    }
  };

  const colorValue = getColorValue();

  return (
    <div className="relative">
      {/* Glow effect */}
      <div 
        className="edge-glow absolute -inset-0.5 rounded-lg opacity-75" 
        style={{ 
          opacity,
          background: `linear-gradient(45deg, rgba(${colorValue},0.4) 0%, rgba(${colorValue},0.1) 100%)`,
          filter: 'blur(8px)',
          zIndex: -1
        }}
      ></div>
      
      {/* Content */}
      {children}
    </div>
  );
}
